import type { ReactNode } from "react";
import { cn } from "./cn.ts";

export const Card = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}): ReactNode => (
  <div
    className={cn(
      "rounded-2xl border border-border bg-card p-5 text-card-foreground shadow-sm sm:p-6",
      className,
    )}>
    {children}
  </div>
);

interface EmptyStateProps {
  title: string;
  body?: string;
  action?: ReactNode;
}

export const EmptyState = ({ title, body, action }: EmptyStateProps): ReactNode => (
  <div
    className={cn(
      "flex flex-col items-center gap-3 rounded-2xl border border-dashed border-input",
      "px-6 py-12 text-center",
    )}>
    <p className="font-display text-2xl font-semibold">{title}</p>
    {body && <p className="max-w-[48ch] text-muted-foreground">{body}</p>}
    {action && <div className="mt-2">{action}</div>}
  </div>
);
